module.exports = __webpack_public_path__ + "img/icons_19.a51ff1d4.png";